module.exports = __webpack_public_path__ + "static/media/lisobnawards.c52567bb.webp";